import { TYPE_INVITE } from 'redhotpie-shared-lib/constants/notificationTypes';
import { IApiResponse } from 'redhotpie-shared-lib/interfaces/IApiResponse';
import { IConversation } from 'redhotpie-shared-lib/interfaces/IConversation';
import { IUserLoginInfo } from 'redhotpie-shared-lib/interfaces/IUser';
import WebIMConfig from 'redhotpie-shared-lib/libs/webIMConfig';
import AlbumDetail from 'redhotpie-shared-lib/models/albumDetail';
import { IComments, ICommentsItems } from 'redhotpie-shared-lib/models/comments';
import InviteResponse from 'redhotpie-shared-lib/models/inviteResponse';
import { PagingInfo } from 'redhotpie-shared-lib/models/pagingInfo';
import { Dispatch } from 'redux';
import * as types from '../constants/actionTypes';
import { MEMBER_SEARCH_SCREEN } from '../constants/category';
import { CHAT_TYPES, EVENT_SELECTION_TYPE, FILE_TYPE_TEXT_INPUT, GroupMatchCriteria, PAGING_DEFAULT } from '../constants/constants';
import TYPE from '../constants/newFeed';
import { generateParamsMemberSearch } from '../functions/utils';
import { IParams, IParamsRequest } from '../interfaces/IAction';
import { IAlbumParams, IGroupPostDetail } from '../interfaces/IGroup';
import { IGroupCanInvited } from '../models/groupDetails';
import commentSystemServices from '../services/commentSystemService';
import groupService from '../services/groupService';
import memberSearchService from '../services/memberSearchService';
import userService from '../services/userService';
import { ICreateGroupParams, IGroup, IGroupBanner, ISearchGroups } from '../types/clubProfile';
import { updateMessageNotificationErrorSuccess } from './commonStateAction';
import { getOrCreateConversation, notifyMessageSent } from './conversationInboxAction';
import { sendInviteGroupMessage } from './messageActions';
import { createUserInvite } from './userActions';
import ClubEvents from 'redhotpie-shared-lib/models/clubEvents';
import { IClubEvent } from '../models/clubEvents';

export function upgradePermissionGroupDetail(data: any) {
  return { type: types.UPGRADE_PERMISSION_GROUP_DETAIL, data };
}
export function getGroupPopularSearchSuccess(data: IGroup[], paginationInfo: any) {
  return { type: types.GET_GROUP_POPULAR_SEARCH_SUCCESS, data, paginationInfo };
}

export function getGroupDesktopPopularSearchSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_DESKTOP_POPULAR_SEARCH_SUCCESS, data, paginationInfo };
}

export function getGroupDetailSuccess(data: any) {
  return { type: types.GET_GROUP_DETAIL_SUCCESS, data };
}

export function getGroupVoteCommentsSuccess(params: { id: any; page: any; size: any }, data: any) {
  return { type: types.GET_GROUP_VOTE_COMMENTS_SUCCESS, params, data };
}

export function getGroupJoinedUsersSuccess(data: any, params?: any) {
  return { type: types.GET_GROUP_JOINED_USERS_SUCCESS, data, params };
}

export function getGroupEventsSuccess(params: any, data: any, total: any) {
  return { type: types.GET_GROUP_EVENTS_SUCCESS, params, data, total };
}

export function getGroupPhotosSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_PHOTOS_SUCCESS, data, paginationInfo };
}

export function getGroupVideosSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_VIDEOS_SUCCESS, data, paginationInfo };
}

export function getGroupAlbumsSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_ALBUMS_SUCCESS, data, paginationInfo };
}

export function getJoinedGroupSuccess(data: any) {
  return { type: types.GET_JOINED_GROUP_SUCCESS, data };
}

export function getMyGroupSuccess(data: any) {
  return { type: types.GET_MY_GROUP_SUCCESS, data };
}

export function mergeDataGroup(data: any) {
  return { type: types.MERGE_DATA_GROUP, data };
}

export function joinAGroupSuccess(clubId: string, currentUserId?: string, isInvited?: boolean, inviteID?: string, status?: string) {
  return { type: types.JOIN_A_GROUP_SUCCESS, data: { clubId, currentUserId, isInvited: isInvited || false, inviteId: inviteID, status } };
}

export function leaveAGroupSuccess(clubId: string, currentUserId?: string) {
  return { type: types.LEAVE_A_GROUP_SUCCESS, data: { clubId, currentUserId } };
}

export function updateDataGroup(key: any, data: any) {
  return { type: types.UPDATE_DATA_GROUP, key, data };
}

export function postUpdateMediaCommentSuccess(params: any, comment?: ICommentsItems) {
  return { type: types.POST_UPDATE_MEDIA_COMMENT_SUCCESS, data: { ...params, comment } };
}

export function updateMediaLikeSuccess(params: { id: number | string; objIndex?: number; objType: string; typeName?: string }) {
  return { type: types.UPDATE_MEDIA_LIKE_SUCCESS, data: { ...params } };
}

export function getPostCommentSuccess(params: any) {
  return { type: types.GET_POST_COMMENT_SUCCESS, params };
}

export function getPostLikeUserSuccess(params: any) {
  return { type: types.GET_POST_LIKE_USERS_SUCCESS, params };
}

export function postCreatePostCommentSuccess(params: any, data: any) {
  return { type: types.POST_CREATE_POST_COMMENT_SUCCESS, params, data };
}

export function postDeletePostCommentSuccess(params: any) {
  return { type: types.POST_DELETE_POST_COMMENT_SUCCESS, params };
}

export function updatePostLikeSuccess(params: any) {
  return { type: types.UPDATE_POST_LIKE_SUCCESS, params };
}

export function updatePostCommentLikeSuccess(params: any) {
  return { type: types.UPDATE_POST_COMMENT_LIKE_SUCCESS, params };
}

export function getGroupActivitySuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_ACTIVITY_SUCCESS, data, paginationInfo };
}

export function getPostDetailSuccess(data: any) {
  return { type: types.GET_POST_DETAIL_SUCCESS, data };
}

export function getAlbumDetailSuccess(data: any) {
  return { type: types.GET_ALBUM_DETAIL_SUCCESS, data };
}

export function resetPostDetailDataSuccess() {
  return { type: types.RESET_POST_DETAIL_DATA_SUCCESS };
}

export function updateAlbumDetailSuccess(data: any) {
  return { type: types.UPDATE_ALBUM_DETAIL_SUCCESS, data };
}

export function getClubsCanBeInvitedSuccess(data: any) {
  return { type: types.GET_CLUB_LIST_CAN_BE_INVITED_SUCCESS, data };
}

export function getMoreRepliesSuccess(params: any) {
  return { type: types.GET_MORE_REPLIES_SUCCESS, params };
}

export function deletePostSuccess(params: { id: number | string; index: number }) {
  return { type: types.DELETE_POST_SUCCESS, params };
}

export function deleteAlbumSuccess(params: { id: number | string; index: number }) {
  return { type: types.DELETE_ALBUM_SUCCESS, params };
}

export function getGroupChatsSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_CHATS_SUCCESS, data, paginationInfo };
}

export function updateMediaUploadingState(params: any) {
  return { type: types.UPDATE_MEDIA_UPLOADING_STATE, params };
}
export function getListUserRequestJoinClubSuccess(params: any) {
  return { type: types.GET_JOIN_USER_REQUEST_SUCCESS, params };
}
export function updateGroupMemberSuccess(params: any) {
  return { type: types.UPDATE_GROUP_MEMBER_SUCCESS, params };
}
export function patchClubUserMemberLevelSuccess(params: { clubId: string; userId: string | number; clubMemberType: string }) {
  return { type: types.PATCH_CLUB_USER_MEMBER_LEVEL_SUCCESS, params };
}
export function patchClubUserBanPostingSuccess(params: { clubId: string; userId: string | number; isBanned: boolean }) {
  return { type: types.PATCH_CLUB_USER_BAN_POSTING_SUCCESS, params };
}
export function getRecommendedGroupsRequest() {
  return { type: types.GET_RECOMMENDED_GROUP_REQUEST };
}
export function getRecommendedGroupsSuccess(data: IGroup[]) {
  return { type: types.GET_RECOMMENDED_GROUP_SUCCESS, data };
}
export function getRecommendedGroupsFailed() {
  return { type: types.GET_RECOMMENDED_GROUP_FAILED };
}

export function updateALbumCommentLikeSuccess(params: any) {
  return { type: types.UPDATE_ALBUM_COMMENT_LIKE_SUCCESS, params };
}

export function getMoreAlbumRepliesSuccess(params: any) {
  return { type: types.GET_MORE_ALBUM_REPLIES_SUCCESS, params };
}
export function mergeDataGroupNotification(data: any) {
  return { type: types.MERGE_DATA_GROUP_NOTIFICATION, data };
}
export function getGroupActivitiesNotificationSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_ACTIVITIES_NOTIFICATION_SUCCESS, data, paginationInfo };
}
export function getGroupJoinRequestNotificationSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_JOIN_REQUEST_NOTIFICATION_SUCCESS, data, paginationInfo };
}
export function getGroupAlertsSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_ALERTS_SUCCESS, data, paginationInfo };
}
export function getSuggestedUsersSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_GROUP_SUGGESTED_USERS_SUCCESS, data, paginationInfo };
}
export function getSuggestedUsersRequest(page: number) {
  return { type: types.GET_GROUP_SUGGESTED_USERS_REQUEST, page };
}
export function updateSuggestedUserFillter(data: any) {
  return { type: types.UPDATE_GROUP_SUGGESTED_USER_FILTER, data };
}
export function resetSuggestedUserFillter() {
  return { type: types.RESET_GROUP_SUGGESTED_USER_FILTER };
}
export function getAllGroupActivityRequest() {
  return { type: types.GET_ALL_GROUP_ACTIVITY_REQUEST };
}

export function updateGroupActivityLoading() {
  return { type: types.UPDATE_GROUP_ACTIVITY_LOADING };
}

export function getAllGroupActivitySuccess(data: any, paginationInfo: any) {
  return { type: types.GET_ALL_GROUP_ACTIVITY_SUCCESS, data, paginationInfo };
}

export function getUserClubNewUsersSuccess(data: any, paginationInfo: any) {
  return { type: types.GET_USER_CLUB_NEW_USERS, data, paginationInfo };
}
export function getRecommendedGroups(params: IParamsRequest) {
  return (dispatch: any) => {
    dispatch(getRecommendedGroupsRequest());
    return groupService.getRecommendedGroups(params).then(res => {
      if (res.success && res.data) {
        dispatch(getRecommendedGroupsSuccess(res.data));
      } else {
        dispatch(getRecommendedGroupsFailed());
      }
      return res;
    });
  };
}

export function postSearchGroups(params: ISearchGroups) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      dispatch(
        mergeDataGroup({
          isLoadingDataPopularSearch: true,
        })
      );
    }
    return groupService.searchGroups(params).then(res => {
      if (res.success) {
        dispatch(
          getGroupPopularSearchSuccess(res.data, {
            page: params.page,
            size: params.size,
            total: res.data.length,
            isHasMore: params.size ? res.data?.length >= params.size : false,
          })
        );
      }
      return res;
    });
  };
}

export function postSearchDesktopPopularGroups(params: ISearchGroups) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      dispatch(
        mergeDataGroup({
          isLoadingDataDesktopPopularSearch: true,
        })
      );
    }
    return groupService.searchPopularGroups(params).then(res => {
      if (res.success) {
        dispatch(
          getGroupDesktopPopularSearchSuccess(res.data, {
            page: params.page,
            size: params.size,
            total: res.total,
            isHasMore: params.size ? res.data?.length >= params.size : false,
          })
        );
      }
      return res;
    });
  };
}

export function searchGroupByTagName(name: string) {
  return (dispatch: any) => {
    dispatch(
      mergeDataGroup({
        isLoadingSearchTag: true,
      })
    );
    return groupService.searchGroupByTagName(name).then(res => {
      if (res.success) {
        dispatch(
          mergeDataGroup({
            isLoadingSearchTag: false,
          })
        );
      }
      return res;
    });
  };
}

export function getGroupDetail(clubID: string, keepOldData?: boolean) {
  return async (dispatch: any) => {
    if (!keepOldData) {
      dispatch(
        mergeDataGroup({
          isLoadingDataGroupDetail: true,
          isLoadedDataGroupDetail: false,
          isLoadingClubPastEvt: false,
          isLoadingClubEvt: false,
          clubPastEvt: [],
          clubEvt: [],
          dataGroupDetail: {
            alerts: [],
            joinedUsers: [],
            friendsAndFav: [],
            pageJoinedUsers: 1,
            isLoadingJoinedUsers: false,
            isHasMoreJoinedUsers: false,
            totalJoinedUser: 0,
            userGrants: {},
          },
          joinedRequest: {
            data: [],
            paginationInfo: {},
            totalRequests: 0,
          },
          photos: {
            data: [],
            paginationInfo: {
              page: 1,
              size: 0,
              totalItems: 0,
              isHasMore: false,
            },
          },
          videos: {
            data: [],
            paginationInfo: {
              page: 1,
              size: 0,
              totalItems: 0,
              isHasMore: false,
            },
          },
          albums: {
            data: [],
            paginationInfo: {
              page: 1,
              size: 0,
              totalItems: 0,
              isHasMore: false,
            },
          },
          activity: {
            data: [],
            paginationInfo: {
              page: 1,
              size: 0,
              totalItems: 0,
              isHasMore: false,
            },
          },
        })
      );
    }
    const res: any = await groupService.getGroupDetail(clubID, false);
    let data = res.data || {};
    if (data?.isOwner || data?.userGrants?.canEditGroup) {
      const res2: any = await groupService.getGroupDetail(clubID, true);

      if (res2.data) {
        data = { ...data, ownerData: { ...res2.data } };
      }
    }
    if (res.success) {
      if (data?.isOwner) {
        dispatch(getListUserRequestJoinClub({ clubId: clubID, page: 1, matching: GroupMatchCriteria.Matched, searchUserName: '' }));
        dispatch(getUserClubAlertByClubID(clubID));
      }
      dispatch(
        getGroupDetailSuccess({
          ...data,
          detail: {
            ...data.detail,
            tags: data.detail.tags.map((tag: any) => ({
              tagId: tag.TagID,
              keyWord: tag.Keyword,
            })),
          },
        })
      );
    } else {
      dispatch(getGroupDetailSuccess({ detail: null }));
    }
    return {
      success: Object.keys(data).length > 0,
      data: data,
    };
  };
}

export function getGroupVoteComments(params: { id: any; page: any; size?: any }) {
  return (dispatch: (arg0: { type: string; params: any; data: any }) => void) => {
    const query = {
      id: params.id,
      page: params.page || 1,
      size: params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
    };
    return groupService.getClubVoteComments(query).then(res => {
      if (res && res.success) {
        dispatch(getGroupVoteCommentsSuccess(query, res.data));
      } else {
        console.log('ERROR: eventHomeAction/getClubVoteComments', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function getGroupJoinedUsers(
  clubID: string,
  params?: { size?: number; page?: number; searchUserName?: string; memberTypes?: number }
) {
  return (dispatch: any) => {
    dispatch(updateDataGroup(['dataGroupDetail', 'isLoadingJoinedUsers'], true));
    return groupService.getGroupJoinedUsers(clubID, params).then(res => {
      if (res.success) {
        dispatch(getGroupJoinedUsersSuccess(res, params));
      }
      return res;
    });
  };
}

export function getGroupEvents(params: {
  clubId: string;
  isOwner?: boolean;
  isApprovedOnly?: boolean;
  page?: number;
  size?: number;
  type?: string;
}) {
  return (dispatch: (arg0: { type: string; data: any; params?: any; total?: any }) => void) => {
    const query = {
      clubId: params.clubId,
      page: params.page || 1,
      size: params.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
      type: params.type || EVENT_SELECTION_TYPE.ALL,
      isOwner: params.isOwner || false,
      isApprovedOnly: params.isApprovedOnly,
    };
    if (!params.page || params.page === 1) {
      if (params.type === EVENT_SELECTION_TYPE.PAST) {
        dispatch(mergeDataGroup({ isLoadingClubPastEvt: true }));
      } else {
        dispatch(mergeDataGroup({ isLoadingClubEvt: true }));
      }
    }
    return groupService.getGroupEvents(query).then(res => {
      if (res && res.success) {
        dispatch(getGroupEventsSuccess({ ...params, ...query }, res.data.data, res.data.total));
      } else {
        console.log('ERROR: groupActions/getGroupEvents', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function updateGroupEventSuccess(eventData: IClubEvent, isEventInThePast: boolean) {
  return {
    type: types.UPDATE_GROUP_EVENT_SUCCESS,
    eventData,
    isEventInThePast,
  };
}

export function getGroupPhotos(params: { clubId: string; isOwner: boolean; page?: number; size?: number }, keepData = false) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      const state: any = {
        isLoadingGroupPhotos: true,
      };
      if (!keepData) {
        state.photos = { data: [], paginationInfo: {} };
      }
      console.log('state', state);
      dispatch(mergeDataGroup(state));
    }
    return groupService.getGroupPhotos(params).then(res => {
      dispatch(getGroupPhotosSuccess(res.data, res.paginationInfo));
      return res;
    });
  };
}

export function getGroupVideos(params: { clubId: string; isOwner: boolean; page?: number; size?: number }, keepData = false) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      const state: any = {
        isLoadingGroupVideos: true,
      };
      if (!keepData) {
        state.videos = { data: [], paginationInfo: {} };
      }
      dispatch(mergeDataGroup(state));
    }
    return groupService.getGroupVideos(params).then(res => {
      if (res.success) {
        dispatch(getGroupVideosSuccess(res.data, res.paginationInfo));
      }
      return res;
    });
  };
}

export function getGroupAlbums(params: { clubId: string; isOwner: boolean; page?: number; size?: number }, keepData = false) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      const state: any = {
        isLoadingGroupAlbums: true,
      };
      if (!keepData) {
        state.albums = { data: [], paginationInfo: {} };
      }
      dispatch(mergeDataGroup(state));
    }
    return groupService.getGroupAlbums(params).then((res: { success: any; data: any; paginationInfo: any }) => {
      if (res.success) {
        dispatch(getGroupAlbumsSuccess(res.data, res.paginationInfo));
      }
      return res;
    });
  };
}

export function postGroupComment(clubID: string) {
  return (dispatch: any) => {
    return groupService.postGroupComment(clubID).then(res => {
      if (res.success) {
        // dispatch(getGroupDetailSuccess(res.data));
      }
      return res;
    });
  };
}

export function postGroupVote(clubID: string, params: { score: number; comment: string; subject: string }) {
  return (dispatch: any) => {
    return groupService.postGroupVote(clubID, params).then(res => {
      return res;
    });
  };
}

export function getJoinedGroup() {
  return (dispatch: any) => {
    dispatch(
      mergeDataGroup({
        isLoadingDataJoinedGroup: true,
      })
    );
    return groupService.getJoinedGroup().then(res => {
      if (res.success) {
        dispatch(getJoinedGroupSuccess(res.data));
      }
      return res;
    });
  };
}

export function getMyGroup() {
  return (dispatch: any) => {
    dispatch(
      mergeDataGroup({
        isLoadingDataMyGroup: true,
      })
    );
    return groupService.getMyGroup().then(res => {
      if (res.success) {
        dispatch(getMyGroupSuccess(res.data));
      }
      return res;
    });
  };
}

export function joinAGroup(clubId: string, currentUserId?: string, isInvited?: boolean, inviteID?: string) {
  return (dispatch: any, getState: any) => {
    return groupService.joinAGroup(clubId).then(res => {
      if (res.success) {
        dispatch(joinAGroupSuccess(clubId, currentUserId, isInvited, inviteID, res.data));
        dispatch(getJoinedGroup());
        const isApprove = res?.data === 'Approved';
        if (typeof WebIMConfig.callbackJoinGroup === 'function') {
          WebIMConfig.callbackJoinGroup();
          WebIMConfig.callbackJoinGroup = null;
        }
        const { dataGroupDetail } = getState().groupReducer;
        if (isApprove && dataGroupDetail && dataGroupDetail.detail?.clubID.toString() === clubId.toString()) {
          // Update
          dispatch(getGroupJoinedUsers(clubId, { size: 10, page: 1 }));
        }
      }
      return res;
    });
  };
}

export function leaveAGroup(clubId: string, currentUserId?: string) {
  return (dispatch: any, getState: any) => {
    const { dataGroupDetail } = getState().groupReducer;
    return groupService.leaveAGroup(clubId).then(res => {
      if (res.success) {
        dispatch(leaveAGroupSuccess(clubId, currentUserId));
        if (dataGroupDetail && dataGroupDetail.detail?.clubID.toString() === clubId.toString()) {
          dispatch(getGroupJoinedUsers(clubId, { size: 10, page: 1 }));
        }
      }
      return res;
    });
  };
}

export function getListUserRequestJoinClub({
  clubId,
  searchUserName,
  matching,
  page,
  size,
}: {
  clubId: string;
  searchUserName?: string;
  matching?: number;
  page?: number;
  size?: number;
}) {
  return (dispatch: any) => {
    return groupService.getListUserRequestJoinClub(clubId, { searchUserName, matching, page, size }).then(res => {
      if (res.success) {
        dispatch(
          getListUserRequestJoinClubSuccess({ data: res.data, paginationInfo: res.paginationInfo, totalRequests: res.totalRequests })
        );
      }
      return res;
    });
  };
}

export function patchApproveUserJoinGroupRequest(clubId: string, userIds: string[]) {
  const params = {
    ClubID: clubId,
    UserIDs: userIds,
  };
  return (dispatch: any) => {
    dispatch(updateGroupMemberSuccess({ clubId, count: userIds.length, userIds: userIds }));
    return groupService.patchApproveUserJoinGroupRequest(clubId, params).then(res => {
      if (res.success) {
        return { success: true };
      }
      return { success: false, message: res.message };
    });
  };
}

export function patchRemoveUserJoinGroupRequest(
  clubId: string,
  userIds: string[],
  { isRemove, isRequest }: { isRemove: boolean; isRequest: boolean }
) {
  const params = {
    ClubID: clubId,
    UserIDs: userIds,
  };
  return (dispatch: any) => {
    dispatch(updateGroupMemberSuccess({ clubId, count: userIds.length, userIds: userIds, isRemove: true, isRequest }));
    return groupService.patchRemoveUserJoinGroupRequest(clubId, params).then((res: any) => {
      if (res.success) {
        return { success: true, message: '' };
      }
      return { success: false, message: res.message as string };
    });
  };
}

export function patchClubUserMemberLevel(clubId: string, userId: string, clubMemberType: string) {
  return (dispatch: any) => {
    return groupService.patchClubUserMemberLevel(clubId, userId, { clubMemberType }).then(res => {
      if (res.success) {
        dispatch(patchClubUserMemberLevelSuccess({ clubId, userId, clubMemberType }));
      }
      return res;
    });
  };
}

export function patchClubUserBanPosting(clubId: string, userId: string, isBanned: boolean) {
  return (dispatch: any) => {
    return groupService.patchClubUserBanPosting(clubId, userId, { isBanned }).then(res => {
      if (res.success) {
        dispatch(patchClubUserBanPostingSuccess({ clubId, userId, isBanned }));
      }
      return res;
    });
  };
}

export function joinAPrivateGroup(clubId: string) {
  return (dispatch: any) => {
    return groupService.joinAPrivateGroup(clubId).then(res => {
      if (res.success) {
        dispatch(joinAGroupSuccess(clubId));
        dispatch(getJoinedGroup());
        if (WebIMConfig.callbackJoinGroup) {
          WebIMConfig.callbackJoinGroup();
          WebIMConfig.callbackJoinGroup = null;
        }
      }
      return res;
    });
  };
}

export function leaveAPrivateGroup(clubId: string) {
  return (dispatch: any) => {
    return groupService.leaveAPrivateGroup(clubId).then(res => {
      if (res.success) {
        dispatch(leaveAGroupSuccess(clubId));
        dispatch(getJoinedGroup());
      }
      return res;
    });
  };
}

export function getGroupActivity(params: { clubId: string; isOwner: boolean; page?: number; size?: number }, keepData = false) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      const state: any = {
        isLoadingGroupActivity: true,
      };
      if (!keepData) {
        state.activity = { data: [], paginationInfo: {} };
      }
      dispatch(mergeDataGroup(state));
    }
    return groupService.getGroupActivity(params).then((res: { success: any; data: { data: any } }) => {
      let data: any = res.data || [];
      let pageSize = params.size ? params.size : 25;
      let paginationInfo = {
        page: params.page || 1,
        size: pageSize,
        isHasMore: data?.length >= pageSize,
      };
      dispatch(getGroupActivitySuccess(data, paginationInfo));
      return res;
    });
  };
}

export function getMediaComment(params: IParams, flatComments?: boolean) {
  return (dispatch: any) => {
    return groupService.getMediaComment(params).then(async res => {
      if (res.success) {
        let { comments }: IComments = res.data;

        if (comments?.length > 0) {
          const body = {
            size: 5,
            listCommentId: comments.map((item: ICommentsItems) => item.commentId).toString(),
          };
          const res2 = await commentSystemServices.getReply(body);
          if (res2.success) {
            const replies = res2.data.items;
            if (replies?.length > 0) {
              if (flatComments) {
                comments = comments.map((item: any) => {
                  const repliesItems = replies.filter((r: any) => item.commentId === r.commentParentId);
                  return {
                    ...item,
                    isHasMoreReply: repliesItems?.length >= 5,
                    pageNumber: repliesItems?.length >= 5 ? 1 : -1,
                  };
                });

                comments = [...comments, ...replies];
              } else {
                comments = comments.map((c: any, index: number) => {
                  const repliesItems = replies.filter((r: any) => c.commentId === r.commentParentId);
                  return {
                    ...c,
                    isHasMoreReply: repliesItems?.length >= 5,
                    pageNumber: repliesItems?.length >= 5 ? 1 : -1,
                    replies: repliesItems,
                  };
                });
              }
            }
          }
        }
        return { ...res, data: { ...res.data, comments: comments, commentsNew: res.data.comments } };
      }
      return res;
    });
  };
}

export function getAlbumCommentSuccess(params: any) {
  return { type: types.GET_ALBUM_COMMENT_SUCCESS, params };
}

export function getAlbumComment(params: IParams, flatComments?: boolean) {
  return (dispatch: any) => {
    return groupService.getAlbumComment(params).then((res: IApiResponse) => {
      if (res.success) {
        let data = res.data?.comments || [];
        let dataJS = res.data?.comments || [];
        let paginationInfo = { page: params.page ? params.page : 1, isHasMore: res.data.page < res.data.totalPages };
        if (data?.length > 0) {
          const body = {
            size: 5,
            listCommentId: data.map((item: any) => item.commentId).toString(),
          };
          return commentSystemServices.getReply(body).then(res2 => {
            if (res2.success) {
              const replies = res2.data.items;
              if (replies?.length > 0) {
                data = data.map((c: any, index: number) => {
                  const repliesItems = replies.filter((r: any) => c.commentId === r.commentParentId);
                  return {
                    ...c,
                    isHasMoreReply: repliesItems?.length >= 5,
                    pageNumber: repliesItems?.length >= 5 ? 1 : -1,
                    replies: repliesItems,
                  };
                });
              }
              // Logic for ReactJS
              dataJS = dataJS.map((item: any) => {
                const repliesItems = replies.filter((r: any) => item.commentId === r.commentParentId);
                return {
                  ...item,
                  isHasMoreReply: repliesItems?.length >= 5,
                  pageNumber: repliesItems?.length >= 5 ? 1 : -1,
                };
              });

              // if (flatComments) {
              //   dispatch(getAlbumCommentSuccess({ data: [...dataJS, ...(res2.data?.items || [])], paginationInfo }));
              // } else {
              dispatch(getAlbumCommentSuccess({ data, paginationInfo }));
              // }
            }
            return {
              ...res,
              data: { comments: [...dataJS, ...(res2.data?.items || [])], paginationInfoComments: paginationInfo, commentsNew: data },
            };
          });
        } else {
          dispatch(getAlbumCommentSuccess({ data, paginationInfo }));
        }
      } else {
        let data: any[] = [];
        let paginationInfo = { page: params.page ? params.page : 1, isHasMore: false };
        dispatch(getAlbumCommentSuccess({ data, paginationInfo }));
      }
      return res;
    });
  };
}

export function postCreateMediaComment(params: IParams) {
  return (dispatch: any) => {
    return groupService.postCreateMediaComment(params).then(res => {
      if (res.success) {
        dispatch(postUpdateMediaCommentSuccess(params));
      }
      return res;
    });
  };
}

export function postCreateAlbumComment(params: IParams) {
  return (dispatch: any) => {
    return groupService.postCreateAlbumComment(params).then(res => {
      console.log('res', res);
      if (res.success) {
        dispatch(postUpdateMediaCommentSuccess({ ...params, objType: 'Album' }, res.data));
      }
      return res;
    });
  };
}

// @params objType 'Photo', 'Video', 'Album'
export function toggleMediaLike(params: {
  id: number | string;
  objIndex?: number;
  objType: string;
  isLiked: boolean;
  parentType?: string;
  parentId?: number | string;
  likeCount?: number;
  typeName?: string;
  userInfo?: IUserLoginInfo;
}) {
  try {
    return (dispatch: any) => {
      let func = !params.isLiked ? groupService.postMediaLike : groupService.deleteMediaLike;
      if (params.objType === 'Album') {
        func = !params.isLiked ? groupService.postAlbumLike : groupService.deleteAlbumLike;
      }
      return func(params.id).then(res => {
        if (res.success) dispatch(updateMediaLikeSuccess(params));
        return res;
      });
    };
  } catch (error) {
    console.log('error', error);
  }
}

export function getUserClubFriend(clubID: string) {
  return (dispatch: any) => {
    return groupService.getUserClubFriend(clubID).then(res => {
      if (res.success) {
        dispatch(updateDataGroup(['dataGroupDetail', 'friendsAndFav'], res.data));
      }
      return res;
    });
  };
}

export function getGroupAlbumMedia(params: { albumId: string; isOwner: boolean; page?: number; size?: number }) {
  return (dispatch: any) => {
    if (!params.page || params.page === 1) {
      dispatch(
        mergeDataGroup({
          isLoadingGroupPhotos: true,
          photos: { data: [], paginationInfo: {} },
        })
      );
    }
    return groupService.getGroupAlbumMedia(params).then((res: { success: any; data: any; paginationInfo: any }) => {
      if (res.success) {
        dispatch(getGroupPhotosSuccess(res.data, res.paginationInfo));
      }
      return res;
    });
  };
}
export function getClubPostComment(params: IParams, flatComments?: boolean) {
  return (dispatch: any) => {
    return groupService.getClubPostComment(params).then((res: IApiResponse) => {
      if (res.success) {
        let data = res.data?.comments || [];
        let dataJS = res.data?.comments || [];
        let paginationInfo = { page: params.page ? params.page : 1, isHasMore: res.data.page < res.data.totalPages };
        if (data?.length > 0) {
          const body = {
            size: 5,
            listCommentId: data.map((item: any) => item.commentId).toString(),
          };
          return commentSystemServices.getReply(body).then(res2 => {
            if (res2.success) {
              const replies = res2.data.items;
              if (replies?.length > 0) {
                data = data.map((c: any, index: number) => {
                  const repliesItems = replies.filter((r: any) => c.commentId === r.commentParentId);
                  return {
                    ...c,
                    isHasMoreReply: repliesItems?.length >= 5,
                    pageNumber: repliesItems?.length >= 5 ? 1 : -1,
                    replies: repliesItems,
                  };
                });
              }
              dispatch(getPostCommentSuccess({ data, paginationInfo }));
              // Logic for ReactJS
              dataJS = dataJS.map((item: any) => {
                const repliesItems = replies.filter((r: any) => item.commentId === r.commentParentId);
                return {
                  ...item,
                  isHasMoreReply: repliesItems?.length >= 5,
                  pageNumber: repliesItems?.length >= 5 ? 1 : -1,
                };
              });
              // if (flatComments) {
              //   dispatch(getPostCommentSuccess({ data: [...dataJS, ...(res2.data?.items || [])], paginationInfo: paginationInfo }));
              // } else {
              dispatch(getPostCommentSuccess({ data, paginationInfo }));
              // }
            }
            return {
              ...res,
              data: { comments: [...dataJS, ...(res2.data?.items || [])], paginationInfoComments: paginationInfo, commentsNew: data },
            };
          });
        } else {
          dispatch(getPostCommentSuccess({ data, paginationInfo }));
        }
      } else {
        let data: any[] = [];
        let paginationInfo = { page: params.page ? params.page : 1, isHasMore: false };
        dispatch(getPostCommentSuccess({ data, paginationInfo }));
      }
      return res;
    });
  };
}

export function getClubLikeUsers(params: IParams) {
  return (dispatch: any) => {
    return groupService.getClubPostLikes(params).then(res => {
      if (res.success) {
        let data = res.data || [];
        let paginationInfo = { page: params.page ? params.page : 1, isHasMore: data?.length === params.size };
        dispatch(getPostLikeUserSuccess({ data, paginationInfo }));
      } else {
        let paginationInfo = { page: params.page ? params.page : 1, isHasMore: false };
        dispatch(getPostLikeUserSuccess({ data: [], paginationInfo }));
      }
      return res;
    });
  };
}

export function postClubPostComment(params: IParams) {
  return (dispatch: any) => {
    return groupService.postClubPostComment(params).then(res => {
      if (res.success) {
        dispatch(postCreatePostCommentSuccess(params, res.data));
      }
      return res;
    });
  };
}

export function deletePostComment(params: { commentId: number; commentIndex?: number; parentIndex?: number; objIndex?: number }) {
  return (dispatch: any) => {
    return commentSystemServices.deleteComment(params.commentId).then((res: { success: any }) => {
      if (res.success) {
        dispatch(postDeletePostCommentSuccess(params));
      }
      return res;
    });
  };
}

export function deleteParentOwnedComment(params: any) {
  return (dispatch: Dispatch<any>) => {
    return userService
      .deleteParentOwnedComment({ commentId: params.commentId })
      .then(res => {
        if (res.success) {
          dispatch(postDeletePostCommentSuccess(params));
        } else {
          console.log('Error: groupActions/deleteParentOwnedComment', res.message);
        }
        return res;
      })
      .catch(e => {
        console.log(`deleteParentOwnedComment: ${e}`);
      });
  };
}

export function togglePostLike(params: {
  id: number | string;
  objIndex: number;
  isLiked: boolean;
  typeName?: string;
  userInfo?: IUserLoginInfo;
}) {
  return (dispatch: any) => {
    let func = !params.isLiked ? groupService.postClubPostLike : groupService.deleteClubPostLike;
    return func(params.id).then(res => {
      if (res.success) dispatch(updatePostLikeSuccess({ ...params, typeName: TYPE.OTG_NAME.OTG_GroupPost }));
      return res;
    });
  };
}

export function toggleAlbumLike(params: {
  id: number | string;
  objIndex: number;
  isLiked: boolean;
  typeName?: string;
  userInfo?: IUserLoginInfo;
}) {
  return (dispatch: any) => {
    let func = !params.isLiked ? groupService.postAlbumLike : groupService.deleteAlbumLike;
    return func(params.id).then(res => {
      if (res.success) dispatch(updatePostLikeSuccess({ ...params, typeName: TYPE.OTG_NAME.OTG_GroupAlbum }));
      return res;
    });
  };
}

export function getMoreReplies({
  commentParentID,
  commentIndex,
  pageNumber,
  isHasMoreReply,
  objType,
}: {
  commentParentID: number;
  pageNumber: number;
  commentIndex: number;
  isHasMoreReply: boolean;
  objType?: string;
}) {
  return (dispatch: any) => {
    const params = { size: 5, commentParentID: commentParentID, page: pageNumber + 1 };
    return commentSystemServices.getReplyFull(params).then(res => {
      if (res.success) {
        if (objType === 'Album') {
          dispatch(
            getMoreAlbumRepliesSuccess({
              commentParentID,
              commentIndex,
              page: pageNumber + 1,
              isHasMoreReply,
              size: 5,
              data: res.data,
            })
          );
        } else {
          dispatch(
            getMoreRepliesSuccess({
              commentParentID,
              commentIndex,
              page: pageNumber + 1,
              isHasMoreReply,
              size: 5,
              data: res.data,
            })
          );
        }
      }
      return res;
    });
  };
}

export function togglePostCommentLike(params: {
  commentId: number;
  commentIndex: number;
  parentId?: number;
  parentIndex?: number;
  isLiked: boolean;
}) {
  return (dispatch: any) => {
    dispatch(updatePostCommentLikeSuccess(params));
    return !params.isLiked
      ? commentSystemServices.postCreateCommentLike({ cmdId: params.commentId })
      : commentSystemServices.deleteCommentLike({ cmdId: params.commentId });
  };
}

export function toggleAlbumCommentLike(params: {
  commentId: number;
  commentIndex: number;
  parentId?: number;
  parentIndex?: number;
  isLiked: boolean;
}) {
  return (dispatch: any) => {
    dispatch(updateALbumCommentLikeSuccess(params));
    return !params.isLiked
      ? commentSystemServices.postCreateCommentLike({ cmdId: params.commentId })
      : commentSystemServices.deleteCommentLike({ cmdId: params.commentId });
  };
}

export function postCommentLike(params: { cmdId: string }) {
  return () => {
    return commentSystemServices.postCreateCommentLike(params).then(res => {
      return res;
    });
  };
}

export function deleteCommentLike(params: { cmdId: string }) {
  return () => {
    return commentSystemServices.deleteCommentLike(params).then(res => {
      return res;
    });
  };
}

export function getClubPostDetail(
  { id, userId, isOwner }: { id: string | number; userId: string; isOwner: boolean },
  keepOldData?: boolean
) {
  return (dispatch: any) => {
    if (!keepOldData) {
      const defaultPostDetail = {
        comments: [],
        isLoadingComments: false,
        paginationInfoComments: { page: 1, size: 24, isHasMore: true, totalItems: 0 },
        likeUsers: [],
        isLoadingLikeUsers: false,
        paginationInfoUsers: { page: 1, isHasMore: true },
        likeCount: 0,
        replyCount: 0,
        isMemberLike: false,
      };
      console.log('no keepOldData');
      dispatch(updateDataGroup(['postDetail'], defaultPostDetail));
    }
    return groupService.getClubPostDetail({ id, isOwner }).then(res => {
      if (res.success && res.data) {
        let data: IGroupPostDetail = res.data;
        const isOwner = userId.toString() === (data.actor.userId || -1).toString();
        return groupService.getGroupPostMedia({ postId: id, isOwner }).then((mediaRes: any) => {
          data.contentItem.media = mediaRes.data || [];
          dispatch(getPostDetailSuccess(data));
          return res;
        });
      }
      return res;
    });
  };
}

export function getAlbumDetail(params: IAlbumParams, keepOldData?: boolean) {
  return (dispatch: any) => {
    if (!keepOldData) {
      const defaultAlbumDetails = {
        likeCount: 0,
        replyCount: 0,
        isMemberLike: false,
        comments: [],
        isLoadingComments: false,
        paginationInfoComments: { page: 1, size: 24, isHasMore: true, totalItems: 0 },
      };
      console.log('no keepOldData');
      dispatch(updateDataGroup(['albumDetail'], defaultAlbumDetails));
    }
    return groupService.getAlbumDetail(params).then(res => {
      if (res.success) {
        dispatch(getAlbumDetailSuccess(res.data));
      }
      return res;
    });
  };
}

export function editClubAlbum(params: { albumId: string | number; title: string }) {
  return (dispatch: any) => {
    return groupService.editClubAlbum(params).then(res => {
      console.log('res editClubAlbum', res);
      if (res.success) {
        dispatch(updateAlbumDetailData(res.data));
      }
      return res;
    });
  };
}

export function updateAlbumDetailData(data: Partial<AlbumDetail>) {
  return (dispatch: any) => {
    dispatch(updateAlbumDetailSuccess(data));
  };
}

export function updatePostDetailSuccess(data: { postId: string | number; message: string }) {
  return { type: types.UPDATE_POST_DETAIL_SUCCESS, data };
}

export function editPostDetail(params: { postId: string | number; message: string; eventId?: string | number }) {
  return (dispatch: any) => {
    return groupService.editClubPost({ postId: params.postId, message: params.message, eventId: params.eventId }).then(res => {
      if (res.success) {
        dispatch(updatePostDetailSuccess(params));
      }
      return res;
    });
  };
}

export function getClubsCanBeInvited(userId: number | string) {
  return (dispatch: any) => {
    return groupService.getClubListCanBeInvited(userId).then(res => {
      if (res.success) {
        dispatch(getClubsCanBeInvitedSuccess(res.data));
      }
    });
  };
}

export function deletePost(params: { id: string | number; index: number }) {
  return (dispatch: any) => {
    dispatch(deletePostSuccess(params));
    return groupService.deletePost(params.id);
  };
}

export function deleteAlbum(params: { id: string | number; index: number }) {
  return (dispatch: any) => {
    dispatch(deleteAlbumSuccess(params));
    return groupService.deleteAlbum(params.id);
  };
}

// id is unique LocalID
export function createClubMediaVideo(params: {
  id: string;
  compress: boolean;
  parentID: string;
  parentType: string;
  file: any;
  sortNumber: number;
}) {
  return (dispatch: any) => {
    dispatch(
      updateMediaUploadingState({
        isUploading: true,
        id: params.id,
        uploadFunc: () => {},
      })
    );
    const onFileUploadProgress = (process: { loaded: number; total: number }) => {
      let percent = Math.ceil((process.loaded / process.total) * 100);
      dispatch(
        updateMediaUploadingState({
          isUploading: true,
          isPendingUploading: false,
          id: params.id,
          percent: percent,
        })
      );
    };
    const onFileUploadError = (error: any) => {
      dispatch(
        updateMediaUploadingState({
          isUploading: false,
          isFinished: true,
          isPendingUploading: false,
          isSuccess: false,
          data: {},
          id: params.id,
          percent: 0,
          uploadFunc: () => {},
        })
      );
      dispatch(updateMessageNotificationErrorSuccess(error.message) as any);
    };
    const onFileUploadComplete = (data: any) => {
      if (data) {
        dispatch(
          updateMediaUploadingState({
            isUploading: false,
            isPendingUploading: false,
            isFinished: true,
            isSuccess: true,
            data: data,
            id: params.id,
            percent: 100,
            uploadFunc: () => {},
          })
        );
      }
    };
    let body = {
      ...params,
      onFileUploadProgress,
      onFileUploadComplete,
      onFileUploadError,
    };
    return groupService.createClubMediaVideo(body);
  };
}

export function createClubMediaPhoto(params: { id: string; parentID: string; parentType: string; file: any; sortNumber: number }) {
  return (dispatch: any) => {
    dispatch(
      updateMediaUploadingState({
        isUploading: true,
        isPendingUploading: false,
        id: params.id,
        percent: 10,
        uploadFunc: () => {},
      })
    );
    return groupService.createClubMediaPhoto(params).then(res => {
      dispatch(
        updateMediaUploadingState({
          isUploading: false,
          isFinished: true,
          isPendingUploading: false,
          isSuccess: res.success,
          id: params.id,
          data: res.data || {},
          percent: 100,
          uploadFunc: () => {},
        })
      );
      if (!res.success && res.message) {
        dispatch(updateMessageNotificationErrorSuccess(res.message) as any);
      }
      return res;
    });
  };
}

export function uploadMultiMedia(params: {
  medias: any[];
  parentID: string;
  parentType: string;
  uploadVideo?: (media: any, parentID: string, parentType: string, index: number) => void;
  uploadPhoto?: (media: any, parentID: string, parentType: string, index: number) => void;
  uploadVideoUrl?: (media: any, parentID: string, parentType: string, index: number) => void;
}) {
  let obj: any = {};
  let pendingUploadingPhotoIds: string[] = [];
  let pendingUploadingVideoIds: string[] = [];
  let pendingUploadingMediaIds: string[] = [];
  params.medias.forEach(media1 => {
    const isVideo = media1.localId?.includes('video');
    const isVideoUrl = media1.localId?.includes(FILE_TYPE_TEXT_INPUT.VIDEO_URL);
    let uploadFunc = () => params.uploadPhoto?.(media1, params.parentID, params.parentType, media1.index);
    if (isVideo) {
      uploadFunc = () => params.uploadVideo?.(media1, params.parentID, params.parentType, media1.index);
    }
    if (isVideoUrl) {
      uploadFunc = () => params.uploadVideoUrl?.(media1, params.parentID, params.parentType, media1.index);
    }
    pendingUploadingMediaIds.push(media1.localId);
    if (isVideo) {
      pendingUploadingVideoIds.push(media1.localId);
    } else {
      pendingUploadingPhotoIds.push(media1.localId);
    }
    obj[media1.localId] = {
      isUploading: false,
      isPendingUploading: true,
      isFinished: false,
      isSuccess: false,
      percent: 0,
      data: {},
      uploadFunc,
    };
  });
  const updateObj = {
    ...obj,
    pendingUploadingCount: params.medias.length,
    pendingUploadingPhotoIds,
    pendingUploadingVideoIds,
    pendingUploadingMediaIds,
    isHaveVideoUploading: false,
    isHavePhotoUploading: false,
  };
  return { type: types.INIT_MEDIA_UPLOADING_STATE, data: updateObj };
}

export function getUserClubJoinedUsers(clubID: string, params: any) {
  return (dispatch: any) => {
    dispatch(updateDataGroup(['dataGroupDetail', 'isLoadingJoinedUsers'], true));
    return groupService.getUserClubJoinedUsers(clubID, params).then((res: IApiResponse) => {
      if (res.success) {
        if (params?.SearchUserName?.length > 0) {
          return res;
        } else {
          dispatch(getGroupJoinedUsersSuccess(res));
        }
      }
      return res;
    });
  };
}

export function deleteAlbumCommentSuccess(params: { commentId: number; commentIndex?: number; parentIndex?: number; objIndex?: number }) {
  return { type: types.DELETE_ALBUM_COMMENT_SUCCESS, params };
}
export function deleteAlbumComment(params: { commentId: number; commentIndex?: number; parentIndex?: number; objIndex?: number }) {
  return (dispatch: any) => {
    return commentSystemServices.deleteComment(params.commentId).then((res: { success: any }) => {
      if (res.success) {
        dispatch(deleteAlbumCommentSuccess(params));
      }
      return res;
    });
  };
}

export function deleteClubMediaSuccess(params: { id: number; objType: string }) {
  return { type: types.DELETE_CLUB_MEDIA_SUCCESS, params };
}

export function deleteClubMedia(params: { id: number; objType: string }) {
  return (dispatch: any) => {
    dispatch(deleteClubMediaSuccess(params));
    // return groupService.deleteClubMedia(params.id);
  };
}

export function deleteClubVoteSuccess(id: number) {
  return { type: types.DELETE_CLUB_COMMENT_SUCCESS, id };
}
export function deleteClubVote(params: { voteId: number; commentId: number; isOwner: boolean; clubId: number }) {
  return (dispatch: any) => {
    dispatch(deleteClubVoteSuccess(params.commentId));
    // groupService.deleteClubValidation(params.commentId);
    return groupService.deleteClubVote(params.voteId, params.clubId, params.isOwner);
  };
}
export function postClubVoteSuccess(params: { id: string | number; score: number; comment?: string }) {
  return { type: types.POST_CREATE_UPDATE_VOTE_SUCCESS, params };
}
export function postClubVote(params: { id: string | number; score: number; comment?: string }) {
  return (dispatch: any) => {
    return groupService.postClubVote(params).then(res => {
      if (res && res.success) {
        dispatch(postClubVoteSuccess(params));
      } else {
        console.log('ERROR: GroupActions/postClubVote', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function removeGroupSuccess(clubId: string) {
  return { type: types.REMOVE_GROUP_SUCCESS, clubId: Number(clubId) };
}

export function removeGroup(clubId: string) {
  return (dispatch: any) => {
    return groupService.removeGroup(clubId).then(res => {
      if (res && res.success) {
        dispatch(removeGroupSuccess(clubId));
      } else {
        console.log('ERROR: GroupActions/removeGroup', (res && res.message) || '');
      }

      return res;
    });
  };
}

export function createGroupSuccess(data: IGroup) {
  return { type: types.CREATE_GROUP_SUCCESS, data };
}

export function updateBannerGroupSuccess(clubID: number, data: IGroupBanner) {
  return { type: types.UPDATE_BANNER_GROUP_SUCCESS, clubID, data };
}

export function createGroup(params: ICreateGroupParams) {
  return (dispatch: any) => {
    return groupService.createGroup(params).then(res => {
      console.log('res', res);
      if (res && res.success) {
        dispatch(createGroupSuccess(res.data as IGroup));
      } else {
        console.log('ERROR: GroupActions/removeGroup', (res && res.message) || '');
      }
      return res;
    });
  };
}

export function updateGroupSuccess(data: IGroup) {
  return { type: types.UPDATE_GROUP_SUCCESS, data };
}

export function updateGroup(clubId: string, params: ICreateGroupParams) {
  return (dispatch: any) => {
    return groupService.updateGroup(clubId, params).then(res => {
      console.log('res updateGroup', res);
      if (res && res.success) {
        dispatch(updateGroupSuccess(res.data as IGroup));
      } else {
        console.log('ERROR: GroupActions/removeGroup', (res && res.message) || '');
      }
      return res;
    });
  };
}

// Groups Notification
export function getGroupActivitiesNotification(params: { pageSize?: number; page?: number }) {
  return (dispatch: any) => {
    dispatch(
      mergeDataGroupNotification({
        isLoadingGroupActivities: true,
        pageNumberGroupActivities: 1,
      })
    );
    return groupService.getGroupActivitiesNotification(params).then(res => {
      if (res.success) {
        dispatch(
          getGroupActivitiesNotificationSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: res.total,
          })
        );
      } else {
        console.log('ERROR: notificationAction/getGroupActivitiesNotification', res.message);
        dispatch(
          getGroupActivitiesNotificationSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: 0,
          })
        );
      }
      return res;
    });
  };
}

export function getGroupJoinRequestNotification(params: { pageSize?: number; page?: number }) {
  return (dispatch: any) => {
    dispatch(
      mergeDataGroupNotification({
        isLoadingGroupJoinRequest: true,
        pageNumberGroupJoinRequest: 1,
      })
    );
    return groupService.getGroupJoinRequestNotification(params).then(res => {
      if (res.success) {
        dispatch(
          getGroupJoinRequestNotificationSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: res.total,
          })
        );
      } else {
        console.log('ERROR: groupAction/getGroupJoinRequestNotification', res.message);
        dispatch(
          getGroupJoinRequestNotificationSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: 0,
          })
        );
      }
      return res;
    });
  };
}
export function getUserClubAlertByClubID(clubID: string) {
  return (dispatch: any) => {
    return groupService.getUserClubAlertByClubID(clubID).then(res => {
      if (res.success) {
        dispatch(updateDataGroup(['dataGroupDetail', 'alerts'], res.data.items));
        dispatch(updateDataGroup(['dataGroupDetail', 'notificationsCount'], res.data.count));
      }
      return res;
    });
  };
}
export function getUserClubAlert(params: { pageSize?: number; page?: number }) {
  return (dispatch: any) => {
    dispatch(
      mergeDataGroupNotification({
        isLoadingGroupAlerts: true,
        pageNumberGroupAlerts: 1,
      })
    );
    return groupService.getUserClubAlert(params).then(res => {
      if (res.success) {
        dispatch(
          getGroupAlertsSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: res.total,
          })
        );
      } else {
        console.log('ERROR: groupAction/getUserClubAlert', res.message);
        dispatch(
          getGroupAlertsSuccess([], { page: params?.page || 1, size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH, total: 0 })
        );
      }
      return res;
    });
  };
}

export function getSuggestedUsers(params: {
  clubId: string;
  pageSize?: number;
  page?: number;
  memberType?: number;
  ageMax?: number;
  ageMin?: number;
}) {
  return (dispatch: any) => {
    dispatch(getSuggestedUsersRequest(params.page || 1));
    if (!params.page || params?.page === 1) {
      dispatch(resetSuggestedUserFillter());
    }
    return groupService.getSuggestedUsers(params).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(
          getSuggestedUsersSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: res.total,
          })
        );
      } else {
        console.log('ERROR: groupAction/getSuggestedUsers', res.message);
        dispatch(
          getSuggestedUsersSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: 0,
          })
        );
      }
      return res;
    });
  };
}
export function searchSuggestedUsers({
  params,
}: {
  params: {
    clubId: string;
    memberTypes?: any;
    minAge?: number;
    maxAge?: number;
    location?: any;
    searchRadius?: number;
    userName?: string;
    pageSize?: number;
    page?: number;
  };
}) {
  let memberType = -1;
  if (!params.userName) {
    const activeGenders = params.memberTypes.filter((gender: { id: number; active: boolean }) => gender.active && gender.id > 0);
    if (activeGenders?.length > 0) {
      memberType = activeGenders.reduce((acc: any, obj: { id: any }) => acc + obj.id, 0);
    }
  }
  const state = {
    filters: {
      orderByType: '',
      minAge: params.minAge,
      maxAge: params.maxAge,
      userName: params.userName,
      location: params.location,
      searchRadius: params.searchRadius,
      memberType: memberType,
      onlineNow: false,
      withPhotos: false,
      isVerified: false,
      hasValidations: false,
      seekingMemberType: '',
    },
    checkedOrderByType: [
      {
        id: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE.MEMBER_LEVEL,
        key: 'featured',
        title: 'All',
        type: 'All',
        name: 'All',
        isCheck: false,
        value: MEMBER_SEARCH_SCREEN.ORDER_BY_TYPE_VALUE.MEMBER_LEVEL,
        nameDesktop: 'Featured',
      },
    ],
  };
  const bodyParams = { Type: 'Advanced', ...generateParamsMemberSearch(state) };
  return (dispatch: any) => {
    dispatch(updateSuggestedUserFillter({ ...params, isHasChangeFilter: !params.userName, isApplyFilter: !params.userName }));
    dispatch(getSuggestedUsersRequest(params.page || 1));
    let funcAction = undefined;
    if (params.userName) {
      funcAction = memberSearchService.postUsersMemberSearchProfile(
        { ...bodyParams, Size: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH, Page: 1 },
        !!params.userName,
        false,
        false
      );
    } else {
      funcAction = groupService.getSuggestedUsers({
        ...params,
        pageSize: params.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
        page: 1,
        memberType,
        ageMax: params.maxAge,
        ageMin: params.minAge,
      });
    }
    return funcAction.then((res: IApiResponse) => {
      if (res.success) {
        let data = !!params.userName ? res.data.usersSearchUserName : res.data;
        let page = (!!params.userName ? res.data.userNameSearch?.page : params.page) || 1;
        let pageSize = !!params.userName ? res.data.userNameSearch?.pageSize : params.pageSize;
        const total = !!params.userName ? 0 : res.total;
        let searchGuid = !!params.userName ? res.data.userNameSearch?.searchGuid : '';

        dispatch(getSuggestedUsersSuccess(data, { page, size: pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH, total, searchGuid }));
      } else {
        console.log('ERROR: groupAction/searchSuggestedUsers', res.message);
        dispatch(
          getSuggestedUsersSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            total: 0,
          })
        );
      }
      return res;
    });
  };
}
export function loadMoreSuggestedUsers(params: {
  pageSize?: number;
  page: number;
  searchGuid: string;
  clubId: string;
  memberTypes?: any;
  minAge?: number;
  maxAge?: number;
}) {
  return (dispatch: any) => {
    dispatch(getSuggestedUsersRequest(params.page));
    if (params.searchGuid) {
      return userService.getUsersProfileMemberSearch({ ...params, SearchGuid: params.searchGuid }).then(res => {
        if (res.success) {
          dispatch(
            getSuggestedUsersSuccess(res.data.users, {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: 0,
              searchGuid: params.searchGuid,
            })
          );
        } else {
          console.log('ERROR: groupAction/loadMoreFilterSuggestedUsers', res);
          dispatch(
            getSuggestedUsersSuccess([], {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: 0,
              searchGuid: params.searchGuid,
            })
          );
        }
        return res;
      });
    } else {
      const activeGenders = params.memberTypes?.filter((gender: { id: number; active: boolean }) => gender.active && gender.id > 0) || [];
      let memberType = -1;
      if (activeGenders?.length > 0) {
        memberType = activeGenders.reduce((acc: any, obj: { id: any }) => acc + obj.id, 0);
      }
      return groupService.getSuggestedUsers({ ...params, memberType, ageMax: params.maxAge, ageMin: params.minAge }).then(res => {
        if (res.success) {
          dispatch(
            getSuggestedUsersSuccess(res.data, {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: res.total,
            })
          );
        } else {
          console.log('ERROR: groupAction/loadMoreFilterSuggestedUsers', res);
          dispatch(
            getSuggestedUsersSuccess([], {
              page: params?.page || 1,
              size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
              total: 0,
            })
          );
        }
        return res;
      });
    }
  };
}

export function getGroupChatCount(params: { clubId: string }) {
  return (dispatch: any) => {
    return groupService.getGroupChatCount(params).then(res => {
      try {
        dispatch(updateDataGroup(['dataGroupDetail', 'chats', 'count'], res.data?.totalCount || 0));
        return { success: true, data: res.data };
      } catch (err) {
        console.log('error in groupService/getGroupChatCount', err);
        return { success: false, data: [], message: err };
      }
    });
  };
}

export function getGroupChats(params: { clubId: string; page: number; pageSize: number }) {
  return (dispatch: any) => {
    return groupService.getGroupChats(params).then(res => {
      try {
        dispatch(
          getGroupChatsSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
          })
        );
        return { success: true, data: res.data };
      } catch (err) {
        console.log('error in groupService/getGroupChats', err);
        return { success: false, data: [], message: err };
      }
    });
  };
}
export function getGroupRecentActivity(params?: { page?: number; size?: number }) {
  return (dispatch: any) => {
    if (!params?.page || params.page === 1) {
      dispatch(getAllGroupActivityRequest());
    } else {
      dispatch(updateGroupActivityLoading());
    }
    return groupService.getGroupRecentActivity(params).then(res => {
      try {
        if (res.success) {
          dispatch(
            getAllGroupActivitySuccess(res.data, {
              page: params?.page || 1,
              size: params?.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            })
          );
        } else {
          dispatch(
            getAllGroupActivitySuccess([], { page: params?.page || 1, size: params?.size || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH })
          );
        }
        return { success: true, data: res.data };
      } catch (err) {
        console.log('error in groupService/getAllGroupActivity', err);
        return { success: false, data: [], message: err };
      }
    });
  };
}

export function resetGroupRecentActivityData() {
  return { type: types.RESET_GROUP_ACTIVITY_SUCCESS };
}

export function resetGroupInviteData() {
  return { type: types.RESET_GROUP_INVITE_SUCCESS };
}

export function getGroupReceivedInvitesSuccess(
  data: InviteResponse[],
  paginationInfo: Pick<PagingInfo, 'page' | 'isHasMore' | 'totalItems'>
) {
  return { type: types.GET_INVITES_GROUP_RECEIVED_SUCCESS, data, paginationInfo };
}

export function getGroupReceivedInvites(params: { page: number; size: number } = { page: 1, size: 25 }) {
  return (dispatch: any) => {
    dispatch({ type: types.GET_INVITES_GROUP_RECEIVED_REQUEST });
    return groupService.getGroupReceivedInvites(params).then(res => {
      if (res.success && res.data) {
        dispatch(
          getGroupReceivedInvitesSuccess(res.data, {
            page: params.page,
            isHasMore: res.page && res.totalPages ? res.page < res.totalPages : false,
            totalItems: res.totalItems || 0,
          })
        );
      } else {
        dispatch({ type: types.GET_INVITES_GROUP_RECEIVED_FAILED });
      }
      return res;
    });
  };
}

export function deleteGroupReceivedInvite(inviteId: number) {
  return (dispatch: any) => {
    return groupService.deleteGroupReceivedInvite(inviteId).then(res => {
      if (res.success) dispatch({ type: types.DELETE_INVITES_GROUP_RECEIVED_SUCCESS, data: { inviteId } });
      return res;
    });
  };
}

export function inviteUserToGroup(
  userId: number,
  groupMetadata: Pick<IGroupCanInvited, 'clubID' | 'privacyType'> & { value: string; expiredAt?: number }
) {
  return (dispatch: any, getState: any) => {
    return dispatch(
      createUserInvite({
        recipientUserId: userId,
        parentId: groupMetadata.clubID,
        parentType: 'Group',
      })
    ).then(async (res: IApiResponse) => {
      if (res.success && res.data) {
        const sendMessage = async () => {
          const {
            authData: { senderMemberLevel, receiverMemberLevel, isSenderMatching, isReceiverMatching },
          } = res.data;

          let conversation = getState().conversationsReducer.data.find((c: IConversation) => c.peerVcard.userId === userId);
          if (!conversation) {
            const res = await dispatch(getOrCreateConversation(userId.toString(), undefined));
            if (res.success && res.data) {
              conversation = res.data as IConversation;
            }
          }

          if (conversation) {
            const msgObj = await dispatch(
              sendInviteGroupMessage({
                chatType: CHAT_TYPES.CHAT,
                chatId: userId.toString(),
                group: {
                  groupId: groupMetadata.clubID,
                  value: groupMetadata.value,
                },
                expts: groupMetadata.expiredAt || 0,
                senderMemberLevel: senderMemberLevel,
                recvMemberLevel: receiverMemberLevel,
                isRecvMatching: isReceiverMatching,
                isSenderMatching: isSenderMatching,
                options: {
                  convId: conversation.id,
                  notificationType: TYPE_INVITE,
                },
              })
            );

            const onMessageDeliverySuccess = (_: any, message: any) => {
              dispatch(
                notifyMessageSent(
                  message.to,
                  message?.body?.data ? JSON.stringify(message.body.data) : message?.body?.type,
                  TYPE_INVITE,
                  '',
                  {
                    messageObject: message,
                  }
                )
              );
            };

            if (WebIMConfig.isEnableStreamManagementFeature) {
              WebIMConfig.onMessageDeliverySuccess = onMessageDeliverySuccess;
            } else {
              onMessageDeliverySuccess('', msgObj);
            }
          } else {
            console.error('Can not get conversation with: ', userId);
          }
        };

        await sendMessage();
      }
      return res;
    });
  };
}
export function postBlockGroup(clubId: string) {
  return (dispatch: any) => {
    return groupService.postBlockGroup(clubId).then(res => {
      if (res?.success) {
        dispatch({ type: types.BLOCK_A_GROUP_SUCCESS, data: Number(clubId) });
      }
      return res;
    });
  };
}

export function postCreateUserClubMediaVideoURL(body: any) {
  return (dispatch: any) => {
    dispatch(
      updateMediaUploadingState({
        isUploading: true,
        isPendingUploading: false,
        id: body.id,
        percent: 10,
        uploadFunc: () => {},
      })
    );
    return groupService.postCreateUserClubMediaVideoURL(body).then(res => {
      dispatch(
        updateMediaUploadingState({
          isUploading: false,
          isFinished: true,
          isPendingUploading: false,
          isSuccess: res.success,
          id: body.id,
          data: res.data || {},
          percent: 100,
          uploadFunc: () => {},
        })
      );
      if (!res.success && res.message) {
        dispatch(updateMessageNotificationErrorSuccess(res.message) as any);
      }
      return res;
    });
  };
}

export function getSuggestedGroup(params: any) {
  return (dispatch: any) => {
    return groupService.searchGroups(params).then(res => {
      if (res.success && res.data) {
        dispatch(getSuggestedGroupSuccess(res.data));
      }
      return res;
    });
  };
}

export function getSuggestedGroupSuccess(data: any) {
  return {
    type: types.GET_SUGGESTED_GROUP_SUCCESS,
    data,
  };
}

export function getUserClubNewUsers(params: { pageSize?: number; page?: number; clubId?: string }) {
  return (dispatch: any) => {
    // dispatch(
    //   mergeDataGroupNotification({
    //     isLoadingGroupJoins: true,
    //     pageNumberGroupJoins: 1,
    //   })
    // );
    return groupService.getUserClubNewUsers(params).then(res => {
      if (res.success) {
        dispatch(
          getUserClubNewUsersSuccess(res.data, {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            totalItems: res.paginationInfo.totalItems,
          })
        );
      } else {
        console.log('ERROR: notificationAction/getGroupActivitiesNotification', res.message);
        dispatch(
          getUserClubNewUsersSuccess([], {
            page: params?.page || 1,
            size: params?.pageSize || PAGING_DEFAULT.PAGE_SIZE_MEMBER_SEARCH,
            totalItems: 0,
          })
        );
      }
      return res;
    });
  };
}
